<!-- Copyright ©2026 Hitachi High-Tech Corporation All Rights Reserved. -->
<ng-container *ngIf="!hasError">
  <div class="layout" >
    <ng-container *ngIf="vm$ | async as vm; else loading">
      <div class="content-wrapper">
        <div class="loader-overlay" *ngIf="!_isReady || isBusy" aria-live="polite" aria-busy="true">
          <mat-spinner></mat-spinner>
        </div>
        <div class="left">
          <aside class="pie-chart">
            <app-hce-sv-pie-chart
              [chrOpts]="chrOpts"
              [pieChartData]="pieChartData"
            ></app-hce-sv-pie-chart>
          </aside>
          <mat-accordion class="filter-accordion">
            <mat-expansion-panel
              [expanded]="filterExpanded"
              (opened)="filterExpanded = true"
              (closed)="filterExpanded = false"
            >
              <mat-expansion-panel-header>
                <mat-panel-title>Sample Filter</mat-panel-title>
              </mat-expansion-panel-header>

              <div class="section">
                <div class="section-title">Samples:</div>

                <mat-radio-group
                  [(ngModel)]="selectedSample"
                  aria-label="Sample or Annotation"
                  class="radio-column"
                  (change)="onSampleChange()"
                >
                  <mat-radio-button
                    *ngIf="analysis?.SampleName as s"
                    [value]="s"
                    class="radio-item"
                    [matTooltip]="s"
                    matTooltipShowDelay="500"
                  >
                    <span class="label-row">
                      <span class="label-text">{{ vm.gender + s }}</span>
                      <span class="label-count">({{ sampleCounts[s] || 0 }})</span>
                    </span>
                  </mat-radio-button>
                  <mat-radio-button
                    *ngFor="let f of selectedAnnotationFiles; trackBy: trackByFile"
                    [value]="f"
                    class="radio-item"
                    [matTooltip]="f + ' (' + (selectedAnnotationByFile[f].length || 0) + ')'"
                    matTooltipShowDelay="500"
                  >
                    <span class="label-row">
                      <span class="label-text">{{ f }}</span>
                      <span class="label-count">({{ sampleCounts[f] || 0 }})</span>
                    </span>
                  </mat-radio-button>
                </mat-radio-group>
              </div>

              <mat-divider></mat-divider>

              <div class="controls">
                <mat-checkbox
                  [checked]="hideSharedSv"
                  (change)="toggleHideSharedSv($event.checked)"
                >
                  <span>Hide Shared SVs</span>
                </mat-checkbox>

                <div class="overlap">
                  <div class="overlap-header">
                    <span>Overlap: </span><strong>{{ overlapPct }}%</strong>
                  </div>

                  <mat-slider min="1" max="100" step="1" class="full-width">
                    <input
                      matSliderThumb
                      [(ngModel)]="overlapPct"
                      (input)="onOverlapPreview($event)"
                      (change)="onOverlapCommit()"
                      aria-label="Overlap percentage"
                    />
                  </mat-slider>
                </div>

                <div class="clear-row">
                  <button mat-raised-button color="primary" (click)="onClearClick()">CLEAR</button>
                </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>

        <div class="right">
          <app-chromosome-view #chrview
            [filterSvList]="svs"
            [contigs]="vm.contigs"
            [references]="vm.references"
            [refsMappingTable]="refNameMap"
            [filterRefNameMap]="filterRefNameMap"
            [annotations]="selectedAnnotationByFile"
            [db]="vm.db"
            [analysis]="analysis"
            (initialized)="onChrViewReady()"
            class="chromosome-view"
          ></app-chromosome-view>
        </div>
      </div>
    </ng-container>

    <ng-template #loading>
      <div class="loader" aria-live="polite" aria-busy="true">
        <mat-spinner></mat-spinner>
      </div>
    </ng-template>
  </div>
</ng-container>
